const STORAGE_KEY = "redirectAfterAuth";

// Internal paths a user may be returned to after authenticating (deep-link
// return). Mirrors the dashboard <Route> group in src/App.tsx and the sidebar
// mainLinks/bottomLinks in src/Sidebar/SidebarDemo.jsx, plus standalone
// protected pages (e.g. /payment-plans) — keep in sync. The whitelist exists
// to prevent open-redirects, so only add real internal protected routes.
export const DASHBOARD_PATHS: ReadonlySet<string> = new Set([
  "/profile",
  "/calendar",
  "/clients",
  "/excluded-contacts",
  "/your-business",
  "/chat",
  "/analytics",
  "/halper-analytics",
  "/invoices",
  "/payments",
  "/marketplace",
  "/accounting",
  "/settings",
  "/payment-plans",
]);

const isAllowed = (path: unknown): path is string =>
  typeof path === "string" &&
  path.startsWith("/") &&
  DASHBOARD_PATHS.has(path);

export const saveRedirectAfterAuth = (path: unknown): void => {
  if (!isAllowed(path)) return;
  try {
    localStorage.setItem(STORAGE_KEY, path);
  } catch {
    // localStorage unavailable (private mode, quota) — silently skip
  }
};

export const peekRedirectAfterAuth = (): string | null => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return isAllowed(value) ? value : null;
  } catch {
    return null;
  }
};

export const consumeRedirectAfterAuth = (): string | null => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
    return isAllowed(value) ? value : null;
  } catch {
    return null;
  }
};

export const clearRedirectAfterAuth = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
